export const getCspNonce = (): string | undefined => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]');

    if (meta == null) return undefined;
    if (meta.content === '') return undefined;
    if (meta.content === 'CSP_NONCE_PLACEHOLDER') return undefined;

    return meta.content;
};

export const applyCspNonce = (element: HTMLElement): void => {
    const nonce = getCspNonce();

    if (nonce == null) return;

    element.setAttribute('nonce', nonce);
};
